import { makeStyles } from '@material-ui/core';
import { PREINFORME_COLORS } from '../../constants/preinformeColors';

/**
 * Estilos locales de la vista de registro de mediciones: cabecera (acento),
 * selector de módulos y áreas de módulo. No toca el tema global.
 */
const medicionesStyles = makeStyles((theme) => ({
	root: {
		minWidth: 0,
		maxWidth: '100%',
	},
	// Barra de acento superior de la cabecera
	accentLine: {
		height: 4,
		margin: theme.spacing(-3, -3, 2, -3),
		borderTopLeftRadius: theme.spacing(1.5),
		borderTopRightRadius: theme.spacing(1.5),
		background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
	},
	headerPaper: {
		overflow: 'hidden',
	},
	headerIdentity: {
		minWidth: 0,
	},
	headerNameBox: {
		minWidth: 0,
	},
	// Botones de la cabecera: en línea, con salto si no caben (375 px)
	headerActions: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: theme.spacing(1),
	},
	headerName: {
		minWidth: 0,
		overflowWrap: 'anywhere',
	},
	selectorTitle: {
		fontWeight: 700,
		color: PREINFORME_COLORS.dark,
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(1.5),
	},
	// 2 columnas hasta 959 px, 4 columnas desde md (960 px)
	selectorGrid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
		gap: theme.spacing(1),
		[theme.breakpoints.up('md')]: {
			gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
		},
	},
	tab: {
		minWidth: 0,
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		gap: theme.spacing(1.5),
		padding: theme.spacing(1.5),
		textAlign: 'left',
		borderRadius: theme.spacing(1.5),
		border: `2px solid ${PREINFORME_COLORS.border}`,
		backgroundColor: PREINFORME_COLORS.surface,
	},
	tabSelected: {
		borderColor: theme.palette.primary.main,
		backgroundColor: PREINFORME_COLORS.blueLight,
	},
	tabFocusVisible: {
		outline: `2px solid ${theme.palette.secondary.main}`,
		outlineOffset: 2,
	},
	tabIcon: {
		flexShrink: 0,
		width: 32,
		height: 32,
		borderRadius: theme.spacing(1),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: theme.palette.primary.main,
		backgroundColor: PREINFORME_COLORS.blueLight,
	},
	tabText: {
		minWidth: 0,
		flex: 1,
	},
	tabLabel: {
		display: 'block',
		fontWeight: 700,
		color: PREINFORME_COLORS.dark,
		overflowWrap: 'anywhere',
	},
	tabDescripcion: {
		display: 'block',
		color: PREINFORME_COLORS.textMuted,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	panelArea: {
		marginTop: theme.spacing(2),
		minWidth: 0,
	},
	placeholder: {
		padding: theme.spacing(3),
		borderRadius: theme.spacing(1.5),
		border: `1px solid ${PREINFORME_COLORS.border}`,
	},
	placeholderTitle: {
		fontWeight: 700,
		color: PREINFORME_COLORS.dark,
	},
	placeholderText: {
		color: PREINFORME_COLORS.textMuted,
	},
	// Panel de captura de una medición (patrón de las features 10-13)
	panelPaper: {
		padding: theme.spacing(2),
		borderRadius: theme.spacing(1.5),
		border: `1px solid ${PREINFORME_COLORS.border}`,
		minWidth: 0,
		[theme.breakpoints.up('sm')]: {
			padding: theme.spacing(3),
		},
	},
	panelHeader: {
		marginBottom: theme.spacing(2),
	},
	panelTitle: {
		fontWeight: 700,
		color: PREINFORME_COLORS.dark,
	},
	panelDescripcion: {
		color: PREINFORME_COLORS.textMuted,
	},
	panelCuerpo: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing(1),
		minWidth: 0,
	},
	campoMedicion: {
		[theme.breakpoints.up('sm')]: {
			maxWidth: 320,
		},
		'& input': {
			fontSize: '1.5rem',
			fontWeight: 700,
			textAlign: 'center',
		},
	},
	// Campo calculado: fondo atenuado y cursor normal, no se edita
	campoSoloLectura: {
		'& .MuiOutlinedInput-root': {
			backgroundColor: PREINFORME_COLORS.blueLight,
		},
		'& input': {
			cursor: 'default',
		},
	},
	panelAcciones: {
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		gap: theme.spacing(1.5),
		marginTop: theme.spacing(2),
		flexWrap: 'wrap',
	},
	// Historial paginado de mediciones (bajo el formulario del panel)
	historial: {
		marginTop: theme.spacing(3),
		minWidth: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing(1),
	},
	historialTitulo: {
		fontWeight: 700,
		color: PREINFORME_COLORS.dark,
	},
	historialEstado: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: theme.spacing(1.5),
	},
	// Red de seguridad: si algo no cabe se desplaza la tabla, nunca la página
	historialTablaContenedor: {
		maxWidth: '100%',
		overflowX: 'auto',
	},
	// A 375 px el toolbar de TablePagination no cabe en una línea
	historialPaginacionToolbar: {
		flexWrap: 'wrap',
		paddingLeft: 0,
		minHeight: 'auto',
	},
	tabRegistrado: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 4,
		fontWeight: 700,
		fontSize: '0.75rem',
		color: theme.palette.success.dark,
	},
	// Rejilla de 2 columnas del lipidograma (también a 375 px)
	rejillaLipidograma: {
		display: 'grid',
		gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
		columnGap: theme.spacing(1.5),
		rowGap: theme.spacing(0.5),
		minWidth: 0,
		// En la rejilla el campo ocupa su celda (anula el maxWidth de 320 desde sm)
		'& $campoMedicion': { maxWidth: 'none' },
		// Label sin encoger: no debe montarse sobre la unidad en celdas estrechas
		'& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
			maxWidth: 'calc(100% - 80px)',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},
	},
	// Slider del perímetro abdominal: mismo ancho máximo que el campo y margen
	// lateral para que el pulgar no se recorte en 40 y en 200
	sliderPerimetro: {
		minWidth: 0,
		padding: theme.spacing(0, 1.5),
		boxSizing: 'border-box',
		[theme.breakpoints.up('sm')]: {
			maxWidth: 320,
		},
	},
	// Clasificación devuelta por el backend tras guardar
	clasificacionPerimetro: {
		marginTop: theme.spacing(1),
		color: PREINFORME_COLORS.dark,
	},
	// Rangos sugeridos del perímetro abdominal: texto de referencia, sin color por categoría
	rangosPerimetro: {
		padding: theme.spacing(1.5),
		borderRadius: theme.spacing(1),
		backgroundColor: PREINFORME_COLORS.blueLight,
		color: PREINFORME_COLORS.dark,
		minWidth: 0,
		overflowWrap: 'anywhere',
		'& ul': {
			margin: theme.spacing(0.5, 0),
			paddingLeft: theme.spacing(2.5),
		},
		'& li': {
			marginBottom: theme.spacing(0.25),
		},
	},
	// Rangos sugeridos de glucometría y espirometría: mismo aspecto que rangosPerimetro
	rangosSugeridos: {
		padding: theme.spacing(1.5),
		borderRadius: theme.spacing(1),
		backgroundColor: PREINFORME_COLORS.blueLight,
		color: PREINFORME_COLORS.dark,
		minWidth: 0,
		overflowWrap: 'anywhere',
		'& ul': {
			margin: theme.spacing(0.5, 0),
			paddingLeft: theme.spacing(2.5),
		},
		'& li': {
			marginBottom: theme.spacing(0.25),
		},
	},
}));

export default medicionesStyles;
